const initBIS = () => {
  if (BIS.urlIsProductPage() === true) {
    BISPopover.ready.then(() => {
      // Exit script if product has no sold out variants.
      if (BIS.popup.variants.length < 1) {
        return;
      }

      // Build and style the Back in Stock button or link
      // that will be inserted into the product page.
      //
      const button = document.createElement('button');
      button.textContent = BIS.Config.button.caption;
      button.setAttribute('href', '#');
      button.className = 'BIS_trigger button brand-blue-btn action_button add_to_cart';
      button.style.display = 'none';
      button.style.marginTop = '10px';
      button.style.color = '#FFFFFF';
      button.style.border = '0';

      // Insert the button into the product page.
      //
      const topAtcBtn = document.getElementById('top-atc-btn');
      const addToCartForm = document.querySelector('form[data-type="add-to-cart-form"]');
      if (topAtcBtn !== null) {
        topAtcBtn.parentNode.insertBefore(button, topAtcBtn.nextSibling);
        topAtcBtn.parentNode.insertBefore(document.createElement('div'), topAtcBtn.nextSibling);
      } else if (addToCartForm !== null) {
        addToCartForm.appendChild(button);
      }

      let variant_id;
      BIS.refreshInlineButton = function () {
        try {
          const variant = BIS.detectVariant(BIS.popup);

          if (variant && BIS.popup.variantIsUnavailable(variant)) {
            variant_id = variant.id;
            button.style.display = 'block';
          } else {
            button.style.display = 'none';
          }
        } catch (e) {
          console.log(e);
        }
      };

      // Open the popup form when the button is clicked.
      //
      button.addEventListener('click', () => {
        BISPopover.form.selectVariant(variant_id);
      });

      setTimeout(BIS.refreshInlineButton, 13);
      document.addEventListener('change', BIS.refreshInlineButton);
    });
  }
};

setTimeout(initBIS, 3000);
